/**
 * @generated SignedSource<<bb35193fa040f66af0a151e70fa16d00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type TimeListEventsCard_EventSession$data = {
  readonly agenda: {
    readonly date: string;
  };
  readonly bookingsPublishedAt: string | null | undefined;
  readonly displayTime: string | null | undefined;
  readonly endAt: string | null | undefined;
  readonly event: {
    readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
    readonly clientEligibleSignUpWindows: ReadonlyArray<{
      readonly opensAt: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly eventSeries: {
      readonly color: CustomColor;
      readonly facility: {
        readonly copyOverrides: {
          readonly course: {
            readonly plural: string;
          } | null | undefined;
        };
        readonly department: {
          readonly name: string;
          readonly type: DepartmentType;
        } | null | undefined;
      };
      readonly image: {
        readonly publicId: string;
      } | null | undefined;
      readonly name: string;
    };
    readonly id: string;
    readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
    readonly spotsAvailable: number | null | undefined;
    readonly tags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly id: string;
  readonly startAt: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useEventLocationLabel_Event">;
  readonly " $fragmentType": "TimeListEventsCard_EventSession";
};
export type TimeListEventsCard_EventSession$key = {
  readonly " $data"?: TimeListEventsCard_EventSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeListEventsCard_EventSession">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeListEventsCard_EventSession",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookingsPublishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EventTagConnection",
          "kind": "LinkedField",
          "name": "tags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventTagEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventTag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "EventSignUpWindow",
          "kind": "LinkedField",
          "name": "clientEligibleSignUpWindows",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "opensAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "accessStatusForClient",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "signUpStatusForClient",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spotsAvailable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSeries",
          "kind": "LinkedField",
          "name": "eventSeries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plural",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Department",
                  "kind": "LinkedField",
                  "name": "department",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": [
                {
                  "alias": "publicId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "renderingKey",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEventLocationLabel_Event"
    }
  ],
  "type": "EventSession",
  "abstractKey": null
};
})();

(node as any).hash = "fc1b9a4c9f6da83cf1be26d5932d8bf0";

export default node;
